import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const PurchaseInvoiceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 3v18l2.3-1.5L9.7 21l2.3-1.5 2.3 1.5 2.4-1.5L19 21V3z" /><path d="M8 8h8M8 12h3M8 16h3M14 15h3M15.5 13.5v3" />
    </g>
  </SvgIcon>
)

export default PurchaseInvoiceIcon
